<template>
	<MoleculeDialog
		:is-open="isOpen"
		is-small
		@close="close"
	>
		<div class="py-20">
			<LazyOrganismFormContact v-if="isOpen" />
		</div>
	</MoleculeDialog>
</template>

<script lang="ts" setup>
withDefaults(
	defineProps<{
		isOpen?: boolean;
	}>(),
	{
		isOpen: false,
	}
);

const {
	trackFormAction,
} = useEventTracking();

const emit = defineEmits(['close']);
const close = () => {
	trackFormAction('contact', 'close');
	emit('close');
};
</script>
